var indentation_default = {
  "indentZero": "LzgXi",
  "indentOne": "_42DMW",
  "indentTwo": "HhnEb",
  "indentThree": "WYW20",
  "indentFour": "_4hsef",
  "indentFive": "mJKYL",
  "indentSix": "qVE28"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
